<template>
    <v-container class="about">
        <v-row class="white-block">
            <v-col md="12" sm="12" xs="12" lg="12">
                <h2 v-html="language =='Ελληνικά'? about.aboutTitle : about.aboutTitleEn"/>
                <p class="mt-5" v-html="language =='Ελληνικά'? about.aboutText.split('#2')[0] : about.aboutTextEn"/>
            </v-col>
            <v-col md="12" sm="12" xs="12" lg="7">
                <p v-html="language =='Ελληνικά'? about.aboutText.split('#2')[1] : about.aboutTextEn"/>
            </v-col>
            <v-col md="12" sm="12" xs="12" lg="5">
                 <v-img
                        height="100%"
                        src="@/assets/02-as-ktirio.jpg"
                />
            </v-col>
        </v-row>

        <v-row class="white-block">
             <v-col md="12" sm="12" xs="12" lg="5">
                 <v-img
                        height="100%"
                        src="@/assets/01-as-ktirio.jpg"
                />
            </v-col>
            <v-col md="12" sm="12" xs="12" lg="7">
                <h2 v-html="language =='Ελληνικά'? about.ereTitle : about.ereTitleEn"/>
                <p class="mt-5" v-html="language =='Ελληνικά'? about.ereText : about.ereTextEn"/>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import restApi from "@/rest-api";

export default {
    props: {
        language: String
    },
    data() {
        return {
            about:{}
        }
    },
    created() {
      this.fetchAbout()
    },
    methods: {
        fetchAbout() {
            var search = `/about`;
            restApi
            .get(search)
            .then(response => {
                 this.about = response.data[0]
            })
            .catch((error) => {
                console.log(error);
            });
      },
    }
}
</script>
<style>
    ul {
        list-style-type: none;
    }
    ul li:before {
        content: '\2013';
        position: absolute;
        margin-left: -15px;
    }
</style>

<style lang="scss" scoped>
    ul {
        list-style-type: none;
        color:darkslateblue;
      }
    ul li:before {
        content: '\2013';
        position: absolute;
        margin-left: -15px;
      }
    .about{
        width:90vw;
    }
    .white-block {
        background:#fff;
        // padding:0% 5% 7% 5%;
        color:#696969;
    }
    @media only screen and (min-width: 600px){
        h1 {
            text-align:center;
            font-size:80px;
            font-weight:normal;
        }
        p {
            font-size:20px;
        }
        .about{
            margin-top: 7%;
        }   

    }
    @media only screen and (max-width: 600px){
        h1 {
            text-align:center;
            font-size:40px;
            font-weight:normal;
        }
        p {
            font-size:20px;
        }
        .about{
            margin-top: 20%;
        } 
    }
</style>